import * as actionTypes from '../constants/rabbitActionTypes';
import { updateObject } from '../../utils';

const initialState = {
  error: null,

  rabbitSignTemplate: null,
  rabbitSignTemplateLoading: false,

  rabbitSignTemplatesLookup: null,
  rabbitSignTemplatesLookupLoading: false,

  saveRabbitSignTemplate: null,
  saveRabbitSignTemplateLoading: false,

  deleteRabbitSignTemplate: null,
  deleteRabbitSignTemplateLoading: false,

  validateRabbitSignSubscription: null,
  validateRabbitSignSubscriptionLoading: false,
};

const getRabbitSignTemplatesStart = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: null,
    error: null,
    rabbitSignTemplatesLookupLoading: true,
  });
};

const getRabbitSignTemplatesSuccess = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: action.rabbitSignTemplatesLookup,
    error: null,
    rabbitSignTemplatesLookupLoading: false,
  });
};

const getRabbitSignTemplatesError = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: null,
    error: action.error,
    rabbitSignTemplatesLookupLoading: false,
  });
};

const saveRabbitSignTemplateStart = (state, action) => {
  return updateObject(state, {
    saveRabbitSignTemplate: null,
    error: null,
    saveRabbitSignTemplateLoading: true,
  });
};

const saveRabbitSignTemplateSuccess = (state, action) => {
  return updateObject(state, {
    saveRabbitSignTemplate: action.saveRabbitSignTemplate,
    error: null,
    saveRabbitSignTemplateLoading: false,
  });
};

const saveRabbitSignTemplateError = (state, action) => {
  return updateObject(state, {
    saveRabbitSignTemplate: null,
    error: action.error,
    saveRabbitSignTemplateLoading: false,
  });
};

const deleteRabbitSignTemplateStart = (state, action) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: null,
    error: null,
    deleteRabbitSignTemplateLoading: true,
  });
};

const deleteRabbitSignTemplateSuccess = (state, action) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: action.deleteRabbitSignTemplate,
    error: null,
    deleteRabbitSignTemplateLoading: false,
  });
};

const deleteRabbitSignTemplateError = (state, action) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: null,
    error: action.error,
    deleteRabbitSignTemplateLoading: false,
  });
};

const getRabbitSignTemplateByIdStart = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplate: null,
    error: null,
    rabbitSignTemplateLoading: true,
  });
};

const getRabbitSignTemplateByIdSuccess = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplate: action.rabbitSignTemplate,
    error: null,
    rabbitSignTemplateLoading: false,
  });
};

const getRabbitSignTemplateByIdError = (state, action) => {
  return updateObject(state, {
    rabbitSignTemplate: null,
    error: action.error,
    rabbitSignTemplateLoading: false,
  });
};

const validateRabbitSignSubscriptionStart = (state, action) => {
  return updateObject(state, {
    validateRabbitSignSubscription: null,
    error: null,
    validateRabbitSignSubscriptionLoading: true,
  });
};

const validateRabbitSignSubscriptionSuccess = (state, action) => {
  return updateObject(state, {
    validateRabbitSignSubscription: action.validateRabbitSignSubscription,
    error: null,
    validateRabbitSignSubscriptionLoading: false,
  });
};

const validateRabbitSignSubscriptionError = (state, action) => {
  return updateObject(state, {
    validateRabbitSignSubscription: null,
    error: action.error,
    validateRabbitSignSubscriptionLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_START:
      return getRabbitSignTemplatesStart(state, action);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_SUCCESS:
      return getRabbitSignTemplatesSuccess(state, action);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_FAIL:
      return getRabbitSignTemplatesError(state, action);

    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_START:
      return saveRabbitSignTemplateStart(state, action);
    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS:
      return saveRabbitSignTemplateSuccess(state, action);
    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_FAIL:
      return saveRabbitSignTemplateError(state, action);

    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_START:
      return deleteRabbitSignTemplateStart(state, action);
    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS:
      return deleteRabbitSignTemplateSuccess(state, action);
    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_FAIL:
      return deleteRabbitSignTemplateError(state, action);

    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_START:
      return getRabbitSignTemplateByIdStart(state, action);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS:
      return getRabbitSignTemplateByIdSuccess(state, action);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL:
      return getRabbitSignTemplateByIdError(state, action);

    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START:
      return validateRabbitSignSubscriptionStart(state, action);
    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS:
      return validateRabbitSignSubscriptionSuccess(state, action);
    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL:
      return validateRabbitSignSubscriptionError(state, action);

    default:
      return state;
  }
};

export default reducer;
